export default "__VITE_ASSET__D0NRpEA1__"